<template>
	<div class="brick view_brick">
		<div class="view_inner">
			<table class="view_tbl">
				<colgroup>
					<col style="width:135px;" />
					<col style="" />
				</colgroup>
				<tbody>
					<!-- <#if Session.session_user.admin_yn == 'Y'> -->
					<template v-if="user.admin_yn == 'Y'">
						<tr>
							<th>Company Name</th>
							<td>
								<input type="text" v-model.trim="company.name" class="tbl_int sm_int" />
								&nbsp;<input type="text" v-model.trim="company.name_information" class="tbl_int sm_int" />
							</td>
						</tr>
						<tr>
							<th>Contact Person</th>
							<td><input type="text" v-model.trim="company.contact_person" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Phone No</th>
							<td><input type="text" v-model.trim="company.phone_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Fax No</th>
							<td><input type="text" v-model.trim="company.fax_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Mail</th>
							<td><input type="text" v-model.trim="company.mail" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>URL</th>
							<td><input type="text" v-model.trim="company.url" class="tbl_int half_int" /></td>
						</tr>
						<tr>
							<th>Address</th>
							<td colspan="4">
								<input class="tbl_int half_int" type="text" v-model.trim="company.address_detail" />
								<a href="javascript:;" class="gray_bt" @click="clearAddress()" style="margin-left:5px;">Clear</a>
							</td>
						</tr>
						<tr>
							<th>City</th>
							<td>
								<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="company.address_city" />
								<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="company.address_state" style="margin-left:5px;" />
								<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="company.address_zipcode" style="margin-left:5px;" />
								<a href="#" class="gray_bt" id="map" type="button" style="margin-left:5px;" @click="openModal('GoogleMap')">Map</a>
							</td>
						</tr>
						<tr>
							<th>Ship Address</th>
							<td colspan="4">
								<input class="tbl_int half_int" type="text" v-model="company.ship_address_detail" />
							</td>
						</tr>
						<tr>
							<th>Ship City</th>
							<td>
								<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="company.ship_address_city" />
								<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="company.ship_address_state" style="margin-left:5px;" />
								<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="company.ship_address_zipcode" style="margin-left:5px;" />
								<input type="text" class="tbl_int ssm_int" placeholder="US" v-model.trim="company.ship_address_country" style="margin-left:5px;" />
							</td>
						</tr>
						<tr>
							<th>UPS Shipper Number</th>
							<td>
								<input class="tbl_int sm_int" type="text" v-model.trim="company.ups_shipper_number" />
							</td>
						</tr>
						<tr>
							<th>UPS User Key</th>
							<td>
								<input class="tbl_int lm_int" type="text" v-model.trim="company.ups_client_id" />
							</td>
						</tr>
						<tr>
							<th>UPS Secret Key</th>
							<td>
								<input class="tbl_int lm_int" type="password" v-model.trim="company.ups_client_secret" />
							</td>
						</tr>
						<tr>
							<th>FedEx Acct. Number</th>
							<td>
								<input class="tbl_int sm_int" type="text" v-model.trim="company.fedex_account_number" />
							</td>
						</tr>
						<tr>
							<th>FedEx API Key</th>
							<td>
								<input class="tbl_int lm_int" type="password" v-model.trim="company.fedex_api_key" />
							</td>
						</tr>
						<tr>
							<th>FedEx Secret Key</th>
							<td>
								<input class="tbl_int lm_int" type="password" v-model.trim="company.fedex_secret_key" />
							</td>
						</tr>
						<tr>
							<th></th>
							<td></td>
						</tr>
						<tr>
							<th>Time Zone</th>
							<td>
								<select v-model="company.time_zone" class="tbl_select mm_int">
									<option v-for="timeZone in this.$timeZones" v-bind:value="timeZone" v-bind:key="timeZone">{{ timeZone }}</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>Retail Store Automatic invoice generation</th>
							<td>
								<input type="checkbox" v-model="company.rs_auto_invoice_generation" />
							</td>
						</tr>
						<tr>
							<th></th>
							<td></td>
						</tr>
					</template>

					<!-- <tr v-for="i in 10" v-bind:key="i"> -->
					<tr v-for="(fm, i) in fav_menus" v-bind:key="fm.path">
						<th>Favorite Menu {{ i + 1 }}</th>
						<td>
							<select v-model="fm.path" class="tbl_select mm_int">
								<option v-for="menu in menus" v-bind:value="menu.path" v-bind:key="menu.path">{{ menu.name }}</option>
							</select>
						</td>
					</tr>

					<tr>
						<th>Password</th>
						<td>
							<a href="javascript:;" type="button" class="gray_bt" @click="openModal('UserChangePassword')">Change Password</a>
						</td>
					</tr>
				</tbody>
			</table>

			<br />

			<AdminSystemSettings v-if="user.admin_yn == 'Y'" :settings="settings" />

			<div class="view_bottom_bt">
				<a href="javascript:;" @click="submit()" type="button" class="search_bt">Save</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'GoogleMap'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select Location</template>
			<template slot="body">
				<GoogleMap :initialLocation="location" v-on:updateLocation="updateLocation" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'UserChangePassword'" :draggable="true">
			<template slot="title">Change Password</template>
			<template slot="body">
				<ChangePassword :user_id="user.user_id" v-on:close="closeModal" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectCompany, apiUpdateCompany } from '@/api/company.js';
import AdminSystemSettings from '@/views/basicinformation/AdminSystemSettings';
import Modal from '@/components/common/Modal';
import ChangePassword from '@/components/common/ChangePassword';
import GoogleMap from '@/components/common/GoogleMap';

export default {
	data: function() {
		return {
			backUri: '/',
			company: {},

			settings: [],
			//fav_menus: [],

			modalName: '',
			showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		menus: function() {
			var ms = this.$session.get('menus').filter(m => m.path.indexOf('add') < 0 && m.path.indexOf('detail') < 0 && m.view_yn == 'Y');
			ms.unshift({ path: null });
			return ms;
			//return this.$session.get('menus').filter(m => m.path.indexOf('add') < 0 && m.path.indexOf('detail') < 0 && m.view_yn == 'Y');
		},
		fav_menus: function() {
			//var fm = this.$session.get('menus').filter(m => m.path.indexOf('add') < 0 && m.path.indexOf('detail') < 0 && m.view_yn == 'Y' && m.fav_order != null);
			var fm = this.$session.get('favMenus');
			for (var i = fm.length; i < 20; i++) fm.push({ path: null });

			return fm;
			//return this.$session.get('menus').filter(m => m.path.indexOf('add') < 0 && m.path.indexOf('detail') < 0 && m.view_yn == 'Y' && m.fav_order != null);
		},
		location() {
			return {
				lat: this.company.lat,
				lng: this.company.lng,
				//place_id: this.user.place_id,
				address_detail: this.company.address_detail,
				address_city: this.company.address_city,
				address_state: this.company.address_state,
				address_zipcode: this.company.address_zipcode,
				country: this.company.country,
			};
		},
	},
	components: {
		ChangePassword,
		GoogleMap,
		Modal,
		AdminSystemSettings,
	},
	methods: {
		// isFavoriteMenu(menu) {
		// 	//console.log(this.fav_menus);
		// 	for (var i = 0; i < this.fav_menus.length; i++)
		// 		if (this.fav_menus[i].path == menu.path) {
		// 			console.log('found');
		// 			return true;
		// 		}
		// 	return false;
		// },
		async selectCompany() {
			const { data } = await apiSelectCompany();
			//console.log(data);
			this.company = data.company;
			this.settings = data.settingList;
		},
		async submit() {
			//console.log(this.fav_menus.filter(f => f.path != null));
			this.company.settings = this.settings;
			this.company.fav_menus = this.fav_menus.filter(f => f.path != null);
			var response = await apiUpdateCompany(this.company);
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.$session.set('favMenus', data.favMenuList);
				//console.log(data.favMenuList);
				//console.log(this.backUri);
				//this.$router.push(this.backUri);
				//this.$forceUpdate();
				this.selectCompany();
			} else {
				this.$toast.error(data.msg);
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		clearAddress() {
			this.company.address_detail = '';
			this.company.address_city = '';
			this.company.address_state = '';
			this.company.address_zipcode = '';
			this.company.country = '';
		},
		updateLocation: function(location) {
			if (location.lat) this.company.lat = location.lat;
			if (location.lng) this.company.lng = location.lng;
			if (location.place_id) this.company.place_id = location.place_id;
			if (location.address_detail && !this.company.address_detail) this.company.address_detail = location.address_detail;
			if (location.address_city && !this.company.address_city) this.company.address_city = location.address_city;
			if (location.address_state && !this.company.address_state) this.company.address_state = location.address_state;
			if (location.address_zipcode && !this.company.address_zipcode) this.company.address_zipcode = location.address_zipcode;
			if (location.country && !this.company.country) this.company.country = location.country;

			//console.log(location);
			//this.user.place_id = placeId;
			//console.log('event received');
			//console.log(this.user);
		},
	},
	created() {
		this.backUri = '/';
		//console.log(this.menus);
		//console.log(this.fav_menus);

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_settings');
		this.$store.commit('setSubTitle', 'Basic Information -> Settings');

		this.selectCompany();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
